const RulesUser = () => {
  return <div>Coming soon</div>;
};

export default RulesUser;
